<template>
	<div class="invite_wrap">
		<div class="basic_wrap">
			<div class="red_top_bg">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{$t('index.myteam')}}</div>
				<!-- <div class="back_right" @click="qrcode = true"><img src="../images/user/qrcoder.png"></div> -->
				<div class="introduce">
					<!-- <div class="line left_line"></div> -->
					<div class="tit">{{$t('share.introduction')}}<br />{{$t('share.introduction1')}}</div>
					<!-- <div class="line right_line"></div> -->
				</div>
			</div>
			<div class="user_top">
				<div class="user_team">
					<p>{{$t('share.team_man')}}:<span>{{ data.teamnum }}</span></p>
					<p>{{$t('share.team_touzi')}}:<span>{{ data.totalpromoney }}</span></p>
				</div>
				<div class="user_team">
					<p>{{$t('share.team_recharge')}}:<span>{{ data.totalrecharge }}</span></p>
					<p>{{$t('share.team_cash')}}:<span>{{ data.totalcash }}</span></p>
				</div>
			</div>
			<div class="list">
				<div class="item itemtitle">
					<p style="width: 20%;">{{$t('share.title1')}}<br />{{$t('share.title1_1')}}</p>
					<p style="width: 20%;">{{$t('share.title2')}}<br />{{$t('share.title2_1')}}</p>
					<p style="width: 20%;">{{$t('share.title3')}}<br />{{$t('share.title3_1')}}</p>
					<p style="width: 20%;">{{$t('share.title4')}}<br />{{$t('share.title4_1')}}</p>
					<p style="width: 20%;">{{$t('share.title5')}}<br />{{$t('share.title5_1')}}</p>
				</div>
				<div class="item" v-for="i in teamList">
					<p>{{i.phone}}</p>
					<p>{{i.m_name}}</p>
					<p><span>{{i.datestr}}</span>{{i.timestr}}</p>
					<p>{{i.totalrecharge?i.totalrecharge:0}}</p>
					<p>{{i.totalcash?i.totalcash:0}}</p>
				</div>
			</div>
			<van-empty :description="$t('item.noData')" v-if="listLength" />
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Empty
	} from 'vant';
	import Clipboard from "v-clipboard";
	Vue.use(Empty).use(Clipboard);
	export default {
		name: "myTeam",
		data() {
			return {
				data: {},
				countTeam: 0,
				countTop1: 0,
				countTop2: 0,
				countTop3: 0,
				active: 1,
				teamList: [],
				listLength: true,
				qrcode: false,
			};
		},
		components: {
			bsHeader
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/myTeam').then((r) => {
					this.data = r.data;
					this.teamList = r.data.userlist;
					if (r.data.userlist.length == 0) {
						this.listLength = true;
					} else {
						this.listLength = false;
					}
					// this.countTop1 = r.data.top1.length;
					// this.countTop2 = r.data.top2.length;
					// this.countTop3 = r.data.top3.length;
					// this.countTeam = this.countTop1 + this.countTop2 + this.countTop3;
				});
			},
			change(num) {
				this.active = num;
				this.teamList = this.data[("top" + num)];
				if (this.teamList.length == 0) {
					this.listLength = true;
				} else {
					this.listLength = false;
				}
			},
			copy() {
				this.$toast({
					className:"toastName",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	.invite_wrap{
		background-color: #2a1164;
	}
	.red_top_bg {
		height: 90px;
		//background: url(../images/user/team/bg.jpg) no-repeat center center;
		//background-size: 100% 100%;
		//background-color: #2a1164;
		position: relative;

		.big_tit {
			position: absolute;
		}

		.back_right {
			position: absolute;
			top: 3px;
			right: 3px;
		}

		.introduce {
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 18px;
			line-height: 25px;
			color: #FFFFFF;
			margin-top: 10px;

			.line {
				width: 36px;
				height: 10px;
			}

			.tit {
				font-size: 12px;
				line-height: 20px;
				padding: 0 15px;
			}

			.left_line {
				background: url(../images/user/left_icon.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.right_line {
				background: url(../images/user/right_icon.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}

		.award_tip {
			font-size: 12px;
			line-height: 18px;
			color: #fff;
			text-align: center;
			margin: 10px auto 0 auto;
		}
	}

	.user_top {
		position: relative;
		background: #FFFFFF;
		border-radius: 5px;
		padding: 0px 10px 15px;
		box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
		
		.user_code{
			width: 72px;
			height: 72px;
			box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.35);
			border-radius: 3px;
			margin: 0 auto;
			
			
			img{
				width: 100%;
				height: 100%;
				border-radius: 3px;
			}
		}

		.user_detail {
			display: flex;
			justify-content: space-between;
			text-align: center;

			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			span {
				margin-left: 85px;
				font-size: 16px;
				font-weight: bold;
			}
		}

		.user_balance {
			text-align: center;
			margin-top: 10px;

			p:nth-child(1) {
				font-size: 12px;
			}

			p:nth-child(2) {
				margin-top: 10px;
				font-weight: bold;
				font-size: 15px;
				color: #FF0000;
			}
		}

		.user_team {
			display: flex;
			justify-content: space-between;
			text-align: left;

			p {
				width: 50%;
				margin-top: 16px;
				font-size: 14px;
				color: #999999;
			}

			p:nth-child(2) {
				text-align: right;
			}

			span {
				color: #4d1bc1;
				font-weight: bold;
			}

		}

		.user_share {
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			background-color: #e9e9e9;
			border-radius: 5px;

			p{
				flex: 1;
				padding: 0 7px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			.tag{
				text-align: center;
				background: #ff5451;
				color: #FFFFFF;
				padding: 6px 10px;
				border-radius: 0 5px 5px 0;
			}
			.tag:first-child{
				border-radius: 5px 0 0 5px;
			}
		}
	}

	.tabs {
		display: flex;
		justify-content: space-between;
		text-align: center;
		margin-top: -64px;
		padding: 15px 15px 10px;

		p {
			width: 32.3%;
			font-size: 14px;
			line-height: 15px;
			padding: 5px;
			border-radius: 5px;
		}

		.active {
			background: #f61a44;
			color: #FFFFFF;
		}
	}

	.list {
		//background: #FFFFFF;

		.item {
			padding: 5px 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			border-bottom: 1px solid #310695;

			p{
				flex: 1;
				line-height: 20px;
				margin-left: auto;
				text-align: center;
				font-size: 12px;
				color: #999999;

				span{
					display: block;
				}
			}
		}
		
		.item:nth-child(1){
			background-color: #181e7e;
			border-top: 1px solid #E3E4E5;
			height: 40px;

			p{
				flex: 1;
				margin-left: auto;
				text-align: center;
				font-size: 12px;
				color: #ffffff;
			}
		}
	}

	.mask {
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.6);
		z-index: 30;

		.share_inner {
			width: 230px;
			height: 280px;
			position: absolute;
			top: 60%;
			left: 0;
			right: 0;
			margin: -232px auto 0 auto;
			background: url(../images/user/share_bg.png) no-repeat center center;
			background-size: 100% 100%;

			.earn {
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}

			.invite {
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}

		}

		.white_bg {
			width: 160px;
			height: 160px;
			background-color: #FFFFFF;
			position: absolute;
			top: 30px;
			left: 35px;
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				width: 143px;
				height: 143px;
			}
		}

		.basic_btn {
			position: absolute;
			left: 0;
			right: 0;
			margin: 0 auto;
			top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
			width: 90%;
		}
	}
	
	
</style>
